import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { LoaderPage, Panel } from 'ht-styleguide';

import styles from './faqpage.module.scss';

/* Dynamic Components */
const GladlyCompliance = dynamic(() => import('@integrations/gladly/Compliance/Gladly.Compliance'), { ssr: false });

// ClientFaqPage component
function ClientFaqPage(props: any) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Clean up any existing instances
    const existingScript = document.getElementById('gladly-script');
    if (existingScript) {
      existingScript.remove();
    }
    delete window.gladlyHCConfig;

    // Set Gladly config
    window.gladlyHCConfig = {
      api: process.env.NEXT_PUBLIC_GLADLY_API,
      orgId: process.env.NEXT_PUBLIC_GLADLY_ORG_ID_FAQ,
      brandId: 'hellotech.com-en-us',
      cdn: 'https://cdn.gladly.com',
      selector: '#gladly-help-center',
    };

    /* Load script function */
    (() => {
      const script = document.createElement('script');
      script.id = 'gladly-script';
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://cdn.gladly.com/help-center/hcl.js';

      const [firstScript] = document.getElementsByTagName('script');
      firstScript.parentNode?.insertBefore(script, firstScript);
    })();

    // Observer for content loading
    const observer = new MutationObserver(mutations => {
      const element = document.querySelector('#gladly-help-center');
      if (element && element.children.length > 0) {
        setIsLoading(false);
        observer.disconnect();
      }
    });

    const target = document.querySelector('#gladly-help-center') || document.body;
    observer.observe(target, {
      childList: true,
      subtree: true,
    });

    /* Cleanup */

    return () => {
      observer.disconnect();
      const script = document.getElementById('gladly-script');
      if (script) {
        script.remove();
      }
      /* Remove gladly globals */
      delete window.gladlyHCConfig;
      delete window.gladlyHCLoaded;

      const helpCenter = document.querySelector('#gladly-help-center');
      if (helpCenter) {
        helpCenter.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className={styles.gladlyHelpCenter}>
      <div className={styles.container}>
        <Panel className={styles.panel} noShadow largeBorderRadius>
          <GladlyCompliance />
        </Panel>
        <div className="marginTop-small1" />
        <Panel className={styles.panel} noShadow largeBorderRadius>
          <div id="gladly-help-center" />
        </Panel>
      </div>

      {isLoading && <LoaderPage />}
    </div>
  );
}

export default ClientFaqPage;
